(function () {
  if (window.__carniCardCart) return;
  window.__carniCardCart = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function cartUrl(p) { return root.replace(/\/$/, '') + p; }
  // The same variant can occupy SEVERAL cart lines (apps add lines with properties or
  // selling plans). Display the SUM, and remember each variant's lines so decrements
  // can target one specific line by key instead of the ambiguous variant id.
  var lastLines = {};
  function syncFromCart(cart) {
    var map = {};
    lastLines = {};
    ((cart && cart.items) || []).forEach(function (it) {
      map[it.variant_id] = (map[it.variant_id] || 0) + it.quantity;
      (lastLines[it.variant_id] = lastLines[it.variant_id] || []).push({
        key: it.key,
        quantity: it.quantity,
        plain: !it.selling_plan_allocation && (!it.properties || Object.keys(it.properties).length === 0)
      });
    });
    document.querySelectorAll('.carni-cartline').forEach(function (form) {
      var vid = parseInt(form.getAttribute('data-variant-id'), 10);
      var qtyWrap = form.querySelector('[data-carni-cartqty]');
      var addBtn = form.querySelector('.carni-add');
      if (!qtyWrap || !addBtn) return;
      if (map[vid]) {
        var valEl = qtyWrap.querySelector('.carni-cartqty__val');
        if (valEl) valEl.textContent = map[vid];
        qtyWrap.hidden = false; addBtn.style.display = 'none';
      } else { qtyWrap.hidden = true; addBtn.style.display = ''; }
    });
  }
  var qtyTimers = {};
  function clearLoading(vid) {
    document.querySelectorAll('.carni-cartline[data-variant-id="' + vid + '"] .carni-cartqty').forEach(function (s) { s.classList.remove('is-loading'); });
  }
  // Cart ops are SERIALIZED per variant (overlapping requests let an older response
  // overwrite a newer one) and never address lines by the AMBIGUOUS variant id:
  // "+" adds one unit via /cart/add.js (merges into the plain line, always nets +1
  // even when apps hold the same variant in other lines), "-" targets one concrete
  // line by its unique key. Display always shows the summed quantity.
  var qtyChain = {};
  function afterOp(vid, opResponse) {
    // authoritative lines come from a fresh cart read; the op response only carries
    // the re-rendered sections for the drawer
    return fetch(cartUrl('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (opResponse && opResponse.sections) cart.sections = opResponse.sections;
        syncFromCart(cart);
        try {
          if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS && FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart, source: 'carni-card-stepper' });
          }
        } catch (err) {}
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      });
  }
  // brief inline message under a card stepper; reuses .carni-qty-note, which already
  // ships light and dark styles from carni-qty-feedback
  function cardNote(vid, msg) {
    document.querySelectorAll('.carni-cartline[data-variant-id="' + vid + '"]').forEach(function (form) {
      var anchor = form.querySelector('[data-carni-cartqty]') || form.querySelector('.carni-add');
      if (!anchor || !anchor.parentElement) return;
      if (anchor.parentElement.querySelector('.carni-qty-note')) return;
      var n = document.createElement('span');
      n.className = 'carni-qty-note';
      n.setAttribute('role', 'status');
      n.textContent = String(msg).slice(0, 70);
      anchor.insertAdjacentElement('afterend', n);
      setTimeout(function () { n.remove(); }, 3200);
    });
  }
  function bundleSections() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
    return sections;
  }
  function stepVariant(vid, dir) {
    qtyChain[vid] = (qtyChain[vid] || Promise.resolve()).then(function () {
      if (dir > 0) {
        return fetch(cartUrl('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: bundleSections().join(',') }) })
          .then(function (r) {
            // Shopify answers a refused add (stock cap, quantity rule) with 422 and a
            // readable description; without this check it parsed as success and the
            // optimistic number just snapped back with no explanation.
            if (!r.ok) return r.json().catch(function () { return null; }).then(function (err) {
              cardNote(vid, (err && (err.description || err.message)) || 'Could not add that one');
              return null;
            });
            return r.json();
          });
      }
      // decrement: /cart/change.js takes an ABSOLUTE quantity, so re-read the live
      // cart first. Computing it from a cached snapshot could raise a line another
      // tab or app just lowered, or wipe units it just added.
      return fetch(cartUrl('/cart.js'), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var mine = (cart.items || []).filter(function (it) { return it.variant_id === vid; });
          if (!mine.length) return null; // already gone: afterOp resyncs the pill
          // prefer a plain line (no hidden properties), else the biggest
          mine.sort(function (a, b) {
            var ap = Object.keys(a.properties || {}).length === 0 ? 1 : 0;
            var bp = Object.keys(b.properties || {}).length === 0 ? 1 : 0;
            return (bp - ap) || (b.quantity - a.quantity);
          });
          var line = mine[0];
          return fetch(cartUrl('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: Math.max(0, line.quantity - 1), sections: bundleSections() }) })
            .then(function (r) { return r.json(); });
        });
    })
      .then(function (resp) { return afterOp(vid, resp); })
      .catch(function () { return afterOp(vid, null); })
      .then(function () { clearLoading(vid); });
  }
  document.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-carni-cinc]'), dec = e.target.closest('[data-carni-cdec]');
    if (!inc && !dec) return;
    var form = (inc || dec).closest('.carni-cartline'); if (!form) return;
    var vid = parseInt(form.getAttribute('data-variant-id'), 10);
    var valEl = form.querySelector('.carni-cartqty__val');
    var qtyWrap = form.querySelector('[data-carni-cartqty]');
    var addBtn = form.querySelector('.carni-add');
    var stepper = form.querySelector('.carni-cartqty');
    var val = parseInt(valEl && valEl.textContent, 10) || 1;
    val += inc ? 1 : -1; if (val < 0) val = 0;
    // Optimistic UI: reflect the change instantly; a loading bar shows until the cart confirms.
    if (valEl) valEl.textContent = val;
    if (val === 0 && qtyWrap && addBtn) { qtyWrap.hidden = true; addBtn.style.display = ''; }
    else if (stepper) { stepper.classList.add('is-loading'); }
    stepVariant(vid, inc ? 1 : -1);
  });
  function refetchCart() { return fetch(cartUrl('/cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(syncFromCart).catch(function () {}); }
  document.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart) syncFromCart(e.detail.cart); else refetchCart(); });
  // Reflect adds/removes from ANY source (theme add-to-cart, drawer, upsells) via the theme's pub/sub.
  function subCart() {
    if (!(window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS && FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate)) return false;
    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (payload) {
      if (payload && payload.source === 'carni-card-stepper') return;
      var cart = payload && (payload.cart || (payload.data && payload.data.cart));
      if (cart && cart.items) { syncFromCart(cart); } else { refetchCart(); }
    });
    return true;
  }
  if (!subCart()) { var st = 0, si = setInterval(function () { if (subCart() || ++st > 40) clearInterval(si); }, 250); }
  refetchCart();
  // Frozen / Organic explainer: tap toggles the tip (mobile); hover/focus handles desktop via CSS.
  document.addEventListener('click', function (e) {
    var flag = e.target.closest('.carni-flag');
    document.querySelectorAll('.carni-flag.is-open').forEach(function (f) { if (f !== flag) f.classList.remove('is-open'); });
    if (flag) { e.preventDefault(); e.stopPropagation(); flag.classList.toggle('is-open'); }
  });
})();
